import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconPhoneStyle0 = stylesCss;

const BiIconPhone$1 = /*@__PURE__*/ proxyCustomElement(class BiIconPhone extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '2f6de4a0e88ebb4c3c0fd5f73af7c090a92431e5', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '3cd55228395007424d4d3fd393f7ba9fd4e1bb80', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '4d05e535d61bf08848f6c9b4ff449c06b8d1a713', "fill-rule": 'evenodd', d: 'M3.875 3.575H9.62v5.493a3.247 3.247 0 0 1-3.246 3.246h-.998v1.996a5.74 5.74 0 0 0 5.741 5.74h1.746v-.747a3.247 3.247 0 0 1 3.247-3.246h5.742v5.494H11.117a7.24 7.24 0 0 1-7.24-7.24V3.574ZM14.362 20.05h5.99v-2.494h-4.243c-.964 0-1.747.782-1.747 1.746zm-8.987-9.237h.998c.964 0 1.746-.782 1.746-1.746V5.075H5.375v5.74Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconPhoneStyle0; }
}, [1, "bi-icon-phone", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-phone"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-phone":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconPhone$1);
            }
            break;
    } });
}

const BiIconPhone = BiIconPhone$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconPhone, defineCustomElement };
